const state = {
  infoStore:
    [
      {
        id: 1,
        title: "Vue.js",
        version: "3.4.38",
        url: "https://v3.ru.vuejs.org"
      },
      {
        id: 2,
        title: "Vue Router",
        version: "4.5.0",
        url: "https://router.vuejs.org"
      },
      {
        id: 3,
        title: "VueX",
        version: "4.1.0",
        url: "https://vuex.vuejs.org"
      },
      {
        id: 4,
        title: "Webpack",
        version: "5.97.1",
        url: "https://webpack.js.org"
      },
      {
        id: 5,
        title: "Vue I18n",
        version: "9.9.1",
        url: "https://vue-i18n.intlify.dev"
      },
      {
        id: 6,
        title: "HTML5",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/HTML/Introduction_to_HTML"
      },
      {
        id: 7,
        title: "CSS3",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/CSS/First_steps"
      },
      {
        id: 8,
        title: "FlexBox CSS",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/CSS/CSS_layout/Flexbox"
      },
      {
        id: 9,
        title: "JavaScript",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/JavaScript"
      },
      {
        id: 10,
        title: "Markdown",
        version: "",
        url: "https://www.markdownguide.org"
      },
      {
        id: 11,
        title: "Google Search Console",
        version: "",
        url: "https://search.google.com/search-console"
      },
      {
        id: 12,
        title: "Google Analytics",
        version: "4.0",
        url: "https://analytics.google.com"
      },
      {
        id: 13,
        title: "Open Graph protocol",
        version: "",
        url: "https://ogp.me"
      },
      {
        id: 14,
        title: "Favicon",
        version: "",
        url: "https://developer.mozilla.org/en-US/docs/Glossary/Favicon"
      },
      {
        id: 15,
        title: "Sitemap",
        version: "",
        url: "https://www.sitemaps.org"
      },
      {
        id: 16,
        title: "Robots.txt",
        version: "",
        url: "https://developers.google.com/search/docs/crawling-indexing/robots/intro"
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};